export default {
  mainContainer: {
    height: "calc(94vh - 115px)",
    overflowY: "auto",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "white",
  },
  mainMobile: {
    height: "calc(100vh - 80px)",
    overflowY: "auto",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "white",
  },
  modalContent: {
    position: "absolute",
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  },
  modalChart: {
    position: "absolute",
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    height: "83%",
    width: "50%",
    backgroundColor: "white",
    overflow: "hidden",
  },
  modalChartMobile: {
    position: "absolute",
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    height: "85%",
    width: "90%",
    backgroundColor: "white",
    overflow: "hidden",
  },
  modalCloseButton: {
    cursor: "pointer",
    marginLeft: "90%",
    borderRadius: "50%",
    top: "0",
    padding: "8px",
    marginTop: "20px",
    position: "fixed",
    background: "#fff",
    color: "#666",
    textAlign: "center",
  },
  modalheader: {
    height: "180px",
    position: "relative",
  },
  modalheaderMobile: {
    height: "150px",
    position: "relative",
  },
  modalinfo: {
    height: "50px",
    marginBottom: "10px",
    padding: "0px 5%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modalinfoMobile: {
    height: "40px",
    marginBottom: "0px",
    padding: "0px 5%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modalchartscr: {
    background: "white",
    height: "calc(100% - 230px)",
    width: "95%",
    margin: "auto",
    overflowY: "auto",
    scrollBehavior: "smooth",
  },
  modalchartscrMobile: {
    background: "white",
    height: "calc(100% - 200px)",
    width: "95%",
    margin: "auto",
    overflowY: "auto",
    scrollBehavior: "smooth",
  },
  datelist: {
    width: "80%",
    margin: "auto",
    overflow: "auto",
    textAlign: "center",
  },
  dateitem: {
    borderRadius: "15px",
    background: "gray",
    color: "white",
    padding: "5px 5px 5px 10px",
    marginRight: "10px",
    width: "100px",
    textAlign: "center",
    display: "inline-block",
  },
  dateitemmobile: {
    borderRadius: "15px",
    background: "gray",
    color: "white",
    padding: "3px 3px 3px 8px",
    marginRight: "8px",
    fontSize: "14px",
    width: "95px",
    textAlign: "center",
    display: "inline-block",
  },
  dateclose: {
    cursor: "pointer",
    marginLeft: "6px",
    borderRadius: "10px",
    background: "#555",
    padding: "0px 5px",
  },
  stockDelayText: {
    fontSize: 12,
    color: "gray",
    fontStyle: "italic",
  },
  //header/
  headerfilterdiv: {
    padding: "0px 0px",
    width: "95%",
    margin: "auto",
    height: "150px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  tickerContainer: {
    height: "95px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tickerInput: {
    width: "200px",
    height: 28,
    fontSize: 18,
    color: "gray",
    // margin: "auto",
    textAlign: "center",
  },
  goButton: {
    marginLeft: 10,
    width: "50px",
    minWidth: 40,
    maxWidth: 40,
    background: "green",
    color: "white",
  },
  btnchart: {
    background: "green",
    color: "white",
    borderRadius: "0px",
    padding: "0px",
    textTransform: "none",
    marginLeft: "20px",
  },
  callbtn: {
    fontWeight: "bold",
    background: "green",
    color: "white",
    borderRadius: "0px",
    padding: "0px",
    textTransform: "none",
    textAlign: "center",
    // borderBottomRightRadius: "0px",
    // borderTopRightRadius: "0px",
  },
  callbtndisable: {
    background: "gray",
    color: "white",
    borderRadius: "0px",
    padding: "0px",
    textTransform: "none",
    // borderBottomRightRadius: "0px",
    // borderTopRightRadius: "0px",
  },
  putbtn: {
    textAlign: "center",
    fontWeight: "bold",
    background: "rgb(200, 26, 0)",
    color: "white",
    borderRadius: "0px",
    padding: "0px",
    textTransform: "none",
    // borderBottomLeftRadius: "0px",
    // borderTopLeftRadius: "0px",
  },
  putbtndisable: {
    background: "gray",
    color: "white",
    borderRadius: "0px",
    padding: "0px",
    textTransform: "none",
    // borderBottomLeftRadius: "0px",
    // borderTopLeftRadius: "0px",
  },
  inputItem: {
    width: "60%",
    // padding: 0,
    fontSize: 13,
    paddingLeft: 8,
    paddingRight: 8,
    // height: 28,
    // margin: "auto",
    // textAlign: "center"
  },
  selectorsFlex: {
    display: "flex",
    flexDirection: "row",

    alignItems: "center",
    width: "100%",
    // width: 220
  },

  ///values
  selectors: {
    width: "25%",
    padding: 15,
    display: "flex",
    flexDirection: "column",
    boxShadow: "none",
    justifyContent: "space-around",
    borderRadius: "0px",
  },
  companyText: {
    fontSize: 19,
  },
  companyTextMobile: {
    fontSize: 14,
  },
  noTickerText: {
    fontStyle: "italic",
    fontSize: 14,
  },
  timestampText: {
    fontSize: 10,
  },
  stockPriceInfo: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    fontWeight: "bold",
  },
  stockPrice: {
    fontSize: 16,
  },
  stockPriceMobile: {
    fontSize: 13,
  },
  posPriceChange: {
    color: "green",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    fontSize: 13,
    marginBottom: 0,
    height: "14px",
  },
  negPriceChange: {
    color: "red",
    // marginLeft: 5,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    fontSize: 13,
    marginBottom: 0,
    height: "14px",
  },
  downArrow: {
    color: "red",
    marginBottom: -10,
    marginRight: -5,
    fontSize: 30,
  },
  downArrowMobile: {
    color: "red",
    marginBottom: -5,
    marginRight: -5,
    marginLeft: -8,
    fontSize: 30,
  },
  upArrow: {
    color: "green",
    marginBottom: -5,
    marginRight: -5,
    fontSize: 30,
  },
  upArrowMobile: {
    color: "green",
    marginBottom: -5,
    marginRight: -5,
    marginLeft: -8,
    fontSize: 30,
  },
  priceChange: {
    marginRight: 3,
  },
  refreshButton: {
    marginTop: 5,
  },
  circularSpinner: {
    marginLeft: 5,
  },
  //tableview
  tablediv: {
    // height: "calc(100% - 150px)",
    position: "relative",
    display: "inline-flex",
    flexDirection: "row",
  },
  headercell: {
    textAlign: "right",
    padding: "2px",
    fontSize: 14,
    background: "rgb(4, 48, 85)",
    color: "white",
    fontWeight: "bold",
    minWidth: "80px",
    cursor: "pointer",
  },
  headercelled: {
    textAlign: "right",
    padding: "2px",
    fontSize: 14,
    background: "green",
    color: "white",
    fontWeight: "bold",
    minWidth: "80px",
    cursor: "pointer",
  },
  headercellst: {
    //position: "fixed",
    top: "0px",
    left: "28.5px",
    textAlign: "center",
    padding: "2px 6px 2px 6px",
    fontSize: 14,
    background: "rgb(60, 60, 60)",
    color: "white",
    fontWeight: "bold",
    minWidth: "63px",
    maxWidth: "63px",
    boxSizing: "border-box",
    zIndex: 5,
  },
  headercellstMobile: {
    textAlign: "center",
    padding: "0px",
    fontSize: 14,
    background: "rgb(60, 60, 60)",
    color: "white",
    fontWeight: "bold",
    minWidth: "55px",
    maxWidth: "55px",
    boxSizing: "border-box",
    zIndex: 5,
  },
  tbcell: {
    padding: "2px",
    fontSize: 12,
    textAlign: "right",
    borderBottom: "1px #AAA solid",
    cursor: "pointer",
    "&:hover": {
      background: "green",
    },
  },
  tbcellhighlight: {
    padding: "2px",
    fontSize: 12,
    textAlign: "right",
    borderBottom: "1px #AAA solid",
    background: "rgba(95, 105, 175, 0.5)",
  },
  strikecell: {
    background: "rgb(60, 60, 60)",
    padding: "2px",
    fontSize: 12,
    textAlign: "center",
    color: "rgb(240,240,240)",
    borderColor: "rgb(150,150,150)",
    minWidth: "63px",
    maxWidth: "63px",
    boxSizing: "border-box",
    "&:hover": {
      background: "green",
    },
  },
  strikecellMobile: {
    position: "sticky",
    left: 0,
    background: "rgb(60, 60, 60)",
    padding: "2px",
    fontSize: 12,
    textAlign: "center",
    color: "rgb(240,240,240)",
    borderColor: "rgb(150,150,150)",
    minWidth: "55px",
    maxWidth: "55px",
    boxSizing: "border-box",
  },
  shaderow: {
    background: "#888",
    height: "30px",
    textAlign: "right",
  },
  normalrow: {
    background: "#FFF",
    height: "30px",
    textAlign: "right",
  },
  normalrowlight: {
    background: "#EEE",
    height: "30px",
    textAlign: "right",
  },
  currentPriceArrowsContainerModal: {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  currentPriceArrowsContainer: {
    position: "relative",
    width: "63px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  //Right side div
  articlesFixed: {
    overflowY: "scroll",
    backgroundColor: "white",
    marginRight: "30px",
    marginLeft: "30px",
    height: "calc(100% - 325px)",
    fontSize: "0.85rem",
  },
  articlesTitleFixed: {
    fontSize: "1.17em",
    fontWeight: "bold",
    marginRight: "30px",
    marginLeft: "30px",
    height: "20px",
    paddingTop: "20px",
    paddingBottom: "10px",
  },
  stockPaper: {
    zIndex: 10,
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "10px",
    height: "100%",
  },
  stockContainer: {
    marginRight: "30px",
    marginLeft: "30px",
    background: "white",
    width: "calc(100% - 60px)",
    height: "275px",
  },
  newsContainer: {
    height: "4rem",
    overflow: "hidden",
    backgroundColor: "white",
    marginRight: "15px",
    padding: "0.2rem",
  },
  leftNewsPic: {
    width: "35%",
    float: "left",
    margin: "5px",
  },
  //right side
  //mobile
  topBar: {
    display: "flex",
    flexDirection: "row",
    // justifyContent: "space-around",
    alignItems: "center",
    background: "rgb(8, 65, 113)",
    height: "50px",
    width: "100%",
    zIndex: 1000,
  },
  tickerInputMobile: {
    width: "150px",
    height: 24,
    fontSize: 16,
    color: "gray",
    // margin: "auto",
    textAlign: "center",
  },
  goButtonMobile: {
    marginLeft: 10,
    height: "30px",
    minWidth: 30,
    maxWidth: 30,
    background: "green",
    color: "white",
  },
  topBarRight: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    cursor: "pointer",
    alignItems: "center",
    color: "white",
  },
  playArrow: {
    color: "white",
    marginRight: 10,
  },
  mobileTxExp: {
    color: "white",
    backgroundColor: "#700606",
    padding: "3px 0px",
    textAlign: "center",
    fontSize: "0.875rem",
    height: "25px",
    boxSizing: "border-box",
    zIndex: 999,
  },
  headerInfoMobile: {
    background: "#fff",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    // top: 0,
    // top: headerHeight + topBarHeight - 1,
    width: "100vw", // Makes the header as wide as the calls/puts table below.
    height: "80px",
    // margin: 'auto',
    zIndex: 1000,
  },
  selectorsMobile: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    boxShadow: "none",
    padding: "10px",
    boxSizing: "border-box",
    borderRadius: 0,
  },
  stCell: {
    display: "flex",
    flexDirection: "row",
    width: "55px",
    height: "30px",
    position: "fixed",
    left: "0px",
    // top: "235px",
    zIndex: 9,
    background: "rgb(60, 60, 60)",
  },

  hover: {
    "&:hover": {
      background: "green",
    },
  },
};



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/OpenInterestStyles.js